import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsQuad = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M19.6918182,20.8035069h-0.0000019c-0.2712002,0-0.5003185,0.2291164-0.5003185,0.5003185v1.9942608
			c0,0.2571735,0.1870346,0.5236988,0.5003185,0.5236988c0.2571735,0,0.5236988-0.1870346,0.5236988-0.5003185v-2.0316696
			l-0.0023365-0.0116901C20.1757717,21.0115814,19.9466534,20.8035069,19.6918182,20.8035069z"
        />
        <path
          d="M23.3319893,19.1575985h-0.0000019h-1.9942608c-0.2571735,0-0.5236988,0.1870346-0.5236988,0.5003185
			c0,0.2571735,0.1870346,0.5236988,0.5003185,0.5236988h2.0199795c0.2665253,0,0.5003204-0.2454834,0.5003204-0.5236988
			C23.8323078,19.3867168,23.6031895,19.1575985,23.3319893,19.1575985z"
        />
        <path
          d="M4.3549404,3.1731129c0.2712002,0,0.5003181-0.2291179,0.5003181-0.5003195V0.6785321
			c0-0.2665241-0.2454834-0.500318-0.5236974-0.500318c-0.2501597,0-0.4582369,0.1987248-0.4979806,0.4746012L3.8312416,0.6645051
			v2.019978l0.0023389,0.0116897C3.8686495,2.9650357,4.1001043,3.1731129,4.3549404,3.1731129z"
        />
        <path
          d="M0.663335,4.8424001L0.6750246,4.844739h2.0082898c0.2665241,0,0.5003181-0.2454839,0.5003181-0.5236988
			c0-0.2501583-0.1987247-0.4582355-0.4746013-0.4979808L2.6973414,3.8207221H0.6890517
			c-0.2665241,0-0.500318,0.2454834-0.500318,0.5236974C0.1887337,4.5945792,0.3874585,4.8026562,0.663335,4.8424001z"
        />
        <path
          d="M2.7090311,19.1575985h-2.019978c-0.2571732,0-0.5236988,0.1870346-0.5236988,0.5003185
			c0,0.2571735,0.1870351,0.5236988,0.5003194,0.5236988h2.019978c0.2571733,0,0.5236988-0.1870346,0.5236988-0.5003185
			C3.2070117,19.4241238,3.0199766,19.1575985,2.7090311,19.1575985z"
        />
        <path
          d="M4.3549404,20.8035069c-0.2712016,0-0.5003195,0.2291164-0.5003195,0.5003185v1.9942608
			c0,0.2571735,0.1870351,0.5236988,0.5003195,0.5236988c0.2571731,0,0.5236974-0.1870346,0.5236974-0.5003185V21.301487
			c0-0.1332626-0.0537724-0.25951-0.1543036-0.3553677C4.6261406,20.8549404,4.4952168,20.8035069,4.3549404,20.8035069z"
        />
        <path
          d="M21.3120079,4.844739h2.0199795c0.2665253,0,0.5003204-0.2454839,0.5003204-0.5236988
			c0-0.2501583-0.1987267-0.4582355-0.4746017-0.4979808l-0.0116901-0.0023372h-2.0082893
			c-0.2571735,0-0.5236988,0.1870351-0.5236988,0.5003181C20.8116894,4.5782132,20.9987259,4.844739,21.3120079,4.844739z"
        />
        <path
          d="M19.6918182,0.1782141h-0.0000019c-0.2712002,0-0.5003185,0.2291177-0.5003185,0.500318v1.9942613
			c0,0.2571733,0.1870346,0.5236988,0.5003185,0.5236988c0.2571735,0,0.5236988-0.1870351,0.5236988-0.5003195V0.6668424
			l-0.0023365-0.0116897C20.1757717,0.3886286,19.9466534,0.1782141,19.6918182,0.1782141z"
        />
        <path
          d="M20.2155151,3.7950039H3.5296469v16.6858673h0.0000014h16.6858673V3.7950039z M19.2172165,19.4802341
			H4.5302858V4.793304h14.6869307V19.4802341z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsQuad;
